import { IAlertRuleRecord } from "../../_models/alerts.interfaces";
import { TemperatureAlertDetailService } from "./temperature-alert-detail/temperature-alert-detail.service";
import { AxleWeightAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/axle-weight-alert-detail/axle-weight-alert-detail.service";
import { GeofenceAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/geofence-alert-detail/geofence-alert-detail.service";
import { InputAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/input-alert-detail/input-alert-detail.service";
import { PowerLossAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/power-loss-alert-detail/power-loss-alert-detail.service";
import { TollAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/toll-alert-detail/toll-alert-detail.service";
import { TyreRecordAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/tyre-record-alert-detail/tyre-record-detail.service";
import { VehicleDiagnosticAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/vehicle-diagnostic-detail/vehicle-diagnostic-detail.service";
import { VideoAlertDetailService } from
    "src/app/main/modules/alerts/components/alert-detail/video-alert-detail/video-alert-detail.service";
import { TranslationService } from "@services/translation.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class AlertDetailService {

    constructor(
        private readonly axleWeightAlertDetailService: AxleWeightAlertDetailService,
        private readonly geofenceAlertDetailService: GeofenceAlertDetailService,
        private readonly inputAlertDetailService: InputAlertDetailService,
        private readonly powerLossAlertDetailService: PowerLossAlertDetailService,
        private readonly temperatureAlertDetailService: TemperatureAlertDetailService,
        private readonly tollAlertDetailService: TollAlertDetailService,
        private readonly translationService: TranslationService,
        private readonly tyreRecordAlertDetailService: TyreRecordAlertDetailService,
        private readonly vehicleDiagnosticAlertDetailService: VehicleDiagnosticAlertDetailService,
        private readonly videoAlertDetailService: VideoAlertDetailService) {
    }

    getAlertDetailExport(record: IAlertRuleRecord): Promise<string> {
        if (!record || !record.alertMetadata) {
            return Promise.resolve(this.translationService.t('Alerts.NoAlarmData'));
        }

        if (record.alertMetadata.AxleWeightOutOfBoundsHistoryId) {
            return new Promise((res, rej) => {
                return this.axleWeightAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.GeofenceId) {
            return new Promise((res, rej) => {
                return this.geofenceAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.InputRecordHistoryId) {
            return new Promise((res, rej) => {
                return this.inputAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.PowerLossHistoryId) {
            return new Promise((res, rej) => {
                return this.powerLossAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.TemperatureRecordId || record.alertMetadata.TemperatureAlarmRecordId) {
            return new Promise((res, rej) => {
                return this.temperatureAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.TollId) {
            return new Promise((res, rej) => {
                return this.tollAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.TyreRecordDataId) {
            return new Promise((res, rej) => {
                return this.tyreRecordAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.VehicleDiagnosticRecordId) {
            return new Promise((res, rej) => {
                return this.vehicleDiagnosticAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        if (record.alertMetadata.VideoEntryId) {
            return new Promise((res, rej) => {
                return this.videoAlertDetailService.getAlertExport(record).then(result => {
                    res(result);
                });
            })
        }
        return Promise.resolve(this.translationService.t('Alerts.NoAlarmData'));
    }
}
